export const mutations = {
  setFiles(state, payload) {
    state.cachedFiles = payload;
  },
};
